import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PageOptimizationTaskFeedback } from '../shared/models/page-optimizations/page-optimization-task-feedback';

@Injectable({
  providedIn: 'root'
})
export class PageOptimizationService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/pageoptimization`;

  constructor(private http: HttpClient) { }

  getLatestContentTaskId(taskId: number): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/latestContentTaskId/${taskId}`);
  }

  getTaskFeedback(taskFeedbackId: number): Observable<PageOptimizationTaskFeedback> {
    return this.http.get<PageOptimizationTaskFeedback>(`${this.baseUrl}/taskfeedback/${taskFeedbackId}`);
  }
}
